<template>
  <div class="stats-over-time-periods">
    <table class="table table-hover table-bordered table-striped" :class="{ 'collapsed': collapse }">
      <thead>
        <tr>
          <th class="text-center">
          </th>
          <th class="text-center">
            Past Week
          </th>
          <th class="text-center">
            Past Month
          </th>
          <th class="text-center">
            Past 3 Months
          </th>
          <th class="text-center">
            Past 6 Months
          </th>
          <th class="text-center">
            Past Year
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td :data-label="''">
            <strong>Total</strong>
          </td>
          <td :data-label="'Past Week'">{{totalWeek}}</td>
          <td :data-label="'Past Month'">{{totalMonth}}</td>
          <td :data-label="'Past 3 Months'">{{total3Month}}</td>
          <td :data-label="'Past 6 Months'">{{total6Month}}</td>
          <td :data-label="'Past Year'">{{totalYear}}</td>
        </tr>
        <tr>
          <td :data-label="''">
            <strong>Average</strong>
          </td>
          <td :data-label="'Past Week'">{{averageWeek}}</td>
          <td :data-label="'Past Month'">{{averageMonth}}</td>
          <td :data-label="'Past 3 Months'">{{average3Month}}</td>
          <td :data-label="'Past 6 Months'">{{average6Month}}</td>
          <td :data-label="'Past Year'">{{averageYear}}</td>
        </tr>
        <tr>
          <td :data-label="''">
            <strong>Count</strong>
          </td>
          <td :data-label="'Past Week'">{{data.week.count}}</td>
          <td :data-label="'Past Month'">{{data.pastMonth.count}}</td>
          <td :data-label="'Past 3 Months'">{{data.past3Month.count}}</td>
          <td :data-label="'Past 6 Months'">{{data.past6Month.count}}</td>
          <td :data-label="'Past Year'">{{data.pastYear.count}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'StatsOverTimePeriods',
  props: {
    data: {
      type: Object,
      default () {
        return {
          week: { total: 0, count: 0, average: 0 },
          pastMonth: { total: 0, count: 0, average: 0 },
          past3Month: { total: 0, count: 0, average: 0 },
          past6Month: { total: 0, count: 0, average: 0 },
          pastYear: { total: 0, count: 0, average: 0 }
        }
      }
    },
    collapse: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  computed: {
    totalWeek () {
      return this.format(this.data.week.total)
    },
    totalMonth () {
      return this.format(this.data.pastMonth.total)
    },
    total3Month () {
      return this.format(this.data.past3Month.total)
    },
    total6Month () {
      return this.format(this.data.past6Month.total)
    },
    totalYear () {
      return this.format(this.data.pastYear.total)
    },
    averageWeek () {
      return this.format(this.data.week.average)
    },
    averageMonth () {
      return this.format(this.data.pastMonth.average)
    },
    average3Month () {
      return this.format(this.data.past3Month.average)
    },
    average6Month () {
      return this.format(this.data.past6Month.average)
    },
    averageYear () {
      return this.format(this.data.pastYear.average)
    }
  },
  methods: {
    format (amount) {
      if (amount) {
        return (
          '$' + amount.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
        )
      } else {
        return '$0.00'
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/displays/StatsOverTimePeriods.vue